import { ContactPreferenceOptions } from "@seneca/notifications-service-types";

import useGetTeacherPreferencesOptions from "features/teachers/pages/settings/components/tabs/TeacherNotificationsPreferencesPage/hooks/useGetPreferencesOptions";
import useGetParentPreferencesOptions from "features/parents/pages/settings/components/ParentNotificationsPreferencesPage/hooks/useGetPreferencesOptions";

const userPreferencesOptions = [
  {
    name: "teacherParentInvite",
    description: "When teacher invites you to view your child's progress"
  },
  {
    name: "teacherSignup",
    description: "When you sign up to seneca as a teacher"
  },
  {
    name: "tenSessionsTutoringParentInvite",
    description: "When your child completes 10 sessions"
  },
  {
    name: "subscribed",
    description: "Unsubscribe from all notifications"
  }
];

export function useGetPreferencesOptions(
  contactType: keyof ContactPreferenceOptions | undefined
) {
  const teacherPreferencesOptions = useGetTeacherPreferencesOptions();
  const parentPreferencesOptions = useGetParentPreferencesOptions();

  if (teacherPreferencesOptions.some(option => option.name === contactType)) {
    return teacherPreferencesOptions;
  }

  if (parentPreferencesOptions.some(option => option.name === contactType)) {
    return parentPreferencesOptions;
  }

  // We only want 1 subscribed option so need to remove from teacher + parent options
  return [
    ...teacherPreferencesOptions.filter(option => option.name !== "subscribed"),
    ...parentPreferencesOptions.filter(option => option.name !== "subscribed"),
    ...userPreferencesOptions
  ];
}
